import React, { useCallback, useEffect, useRef, useState } from "react";
import "./Nudges.css";
import { useParams } from "react-router-dom";
import ScreenLoader from "../../../HtmlElements/ScreenLoader";
import { fetchAccountBUNudges } from "../../../../services/accIqService";
import * as FeatherIcon from 'react-feather';
import { useConfig } from "../../../../context/AppConfigContext";
import NudgesTiles from "./NudgesTiles";
import { useSelector } from "react-redux";

export default function Nudges({active_tab_key}) {

  const {appConfig} = useConfig();

  const { account_info} = useSelector(state=>state?.accountsReducer)

  const [business_units, setBusinessUnits] = useState([]);
  const [tabs, setTabs] = useState([]);
  const [loader, setLoader] = useState(true);
  const [activeUnit, setActiveUnit] = useState("");
  const [activeUnitNudges, setActiveUnitNudges] = useState([]);
  const { accountId, accountName, clientName } = useParams();
  const tabContainerRef = useRef(null); // Reference for tab container
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);
  const [showArrows, setShowArrows] = useState(false); // New state to control arrow visibility

  const [activeAccordion, setActiveAccordion] = useState(0);  // Track accordion state (open/closed)
  const [selectedItems, setSelectedItems] = useState([]);

  useEffect(() => {
    if(active_tab_key === 'nudges'){
      updateScrollButtons()
    }
}, [active_tab_key]);

  const updateBusinessUnits = () => {
    const business_units = account_info?.business_units || [];
    setBusinessUnits(business_units)
    const bu_tabs = business_units.map((unit) => unit.name);
    setTabs(bu_tabs)
    setActiveUnit(bu_tabs[0]);
  }

  useEffect(() => {
    updateBusinessUnits();
  }, [account_info, accountId, accountName, clientName]);

  const fetchSegmentNudges = useCallback(
    async (bu_unit) => {
      setLoader(true);

      try {
        let acc_bu_nudges = await fetchAccountBUNudges(
          accountName,
          clientName,
          bu_unit
        );

        const nudges_types_key_val = appConfig?.nudges_types_key_val || [];
        const sortOrder = nudges_types_key_val.map(item => Object.keys(item)[0]);

        // Sort acc_bu_nudges based on sortOrder
        acc_bu_nudges?.result.sort((a, b) => {
            return sortOrder.indexOf(a._id) - sortOrder.indexOf(b._id);
        });

        // Map through nudges and assign labels and unique ids
        acc_bu_nudges?.result.map((nudge_type_data, index) => {
          const nudge_type_key = nudge_type_data._id;
          
          // Find the label based on the key
          const labelObj = nudges_types_key_val.find(item => item[nudge_type_key]);
          nudge_type_data._id = labelObj ? labelObj[nudge_type_key] : nudge_type_key;

          // Map through data and update id values
          nudge_type_data.data.map((nudge_data, index_2) => {
              nudge_data.id = index + "_" + index_2;
          });
        });

        setActiveUnitNudges(acc_bu_nudges?.result);

      } catch (error) {
        console.error("Error fetching segment data:", error);
      }
      setLoader(false);
    },
    [accountName, clientName]
  );

  useEffect(() => {
    if (activeUnit) {
      // setSelectedItems([]);  // Uncheck all checkboxes
      // let userStat = getUserStatsObject("Nudges", "page_load", "Data: "+activeUnit+", Page Source: "+accountName, window.location.href, accountId);
      // recordActivity(userStat);
      fetchSegmentNudges(activeUnit);
    }
  }, [activeUnit, fetchSegmentNudges, appConfig?.nudges_types_key_val]);

  

  const updateScrollButtons = () => {
    const tabContainer = tabContainerRef.current;
    if (tabContainer) {
      const canScrollLeftValue = tabContainer.scrollLeft > 0;
      const canScrollRightValue = tabContainer.scrollLeft + tabContainer.clientWidth < tabContainer.scrollWidth;

      setCanScrollLeft(canScrollLeftValue);
      setCanScrollRight(canScrollRightValue);

      // Show arrows only if the content is scrollable
      setShowArrows(tabContainer.scrollWidth > tabContainer.clientWidth);
    }
  };

  const scrollLeft = () => {
    const tabContainer = tabContainerRef.current;
    if (tabContainer) {
      tabContainer.scrollBy({ left: -200, behavior: 'smooth' });
    }
  };

  const scrollRight = () => {
    const tabContainer = tabContainerRef.current;
    if (tabContainer) {
      tabContainer.scrollBy({ left: 200, behavior: 'smooth' });
    }
  };

  useEffect(() => {
    updateScrollButtons(); // Initially check if scrolling is needed
    const tabContainer = tabContainerRef.current;
    
    if (tabContainer) {
      tabContainer.addEventListener('scroll', updateScrollButtons);
      window.addEventListener('resize', updateScrollButtons); // Recheck on window resize
    }

    return () => {
      if (tabContainer) {
        tabContainer.removeEventListener('scroll', updateScrollButtons);
      }
      window.removeEventListener('resize', updateScrollButtons);
    };
  }, [tabs]);

  useEffect(() => {
    setActiveAccordion('0'); // Set first accordion to open
    setSelectedItems([]); // Set selected items to null
  }, [activeUnit]);

  if (!account_info || !business_units.length) {
    return <></>;
  }

  return (
    <div className="nudges_wrapper">
      {loader && <ScreenLoader />}
      <div className="business_seg_tabs">
        <div className="navbar navbar-expand-lg container-fluid custom_subnavbar" >
          {showArrows && (
            <>
              <button
                className="scroll-btn left-arrow"
                onClick={scrollLeft}
                disabled={!canScrollLeft}
              >
                <FeatherIcon.ArrowLeftCircle className='icons_table mr-1' />
              </button>
            </>
          )}
          <ul className="nav nav-tabs custom_nav_tab" ref={tabContainerRef}>
            {tabs.map((tab) => (
              <li className="nav-item" key={`nudge_seg_unit_${tab}`}>
                <a
                  className={`nav-link ${activeUnit === tab ? "active" : ""}`}
                  onClick={() => setActiveUnit(tab)}
                >
                  {tab}
                </a>
              </li>
            ))}
          </ul>
          {showArrows && ( // Conditionally render arrows based on `showArrows` state
            <>
              <button
                className="scroll-btn right-arrow"
                onClick={scrollRight}
                disabled={!canScrollRight}
              >
                <FeatherIcon.ArrowRightCircle className='icons_table mr-1' />
              </button>
            </>
          )}
        </div>
      </div>

      {activeUnitNudges.length > 0 ? (<div className="nudges_accordian_block pb-4">
        <div className="container-fluid">
          <div className="nudges_custom_wrapper">
            <div className="custom_card_block_nud">
         
              <div className="nudges_custom_block">
                <div className="nudges_custom_accordian">
                  {activeUnit && (
                    <NudgesTiles
                      activeUnitNudges={activeUnitNudges}
                      activeAccordion={activeAccordion}
                      setActiveAccordion={setActiveAccordion}
                      selectedItems={selectedItems}
                      setSelectedItems={setSelectedItems}
                      activeUnit={activeUnit}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>) : (<div className="container"><div className="no_nudges_div mt-4">No nudges found !!!</div></div>)}

    </div>
  );
}
